/* Layout */
import Layout from '@/views/layout/LayoutOverview';
import Overview from '@/views/overview/index';

const overviewRouter = {
  path: '/manage/overview',
  name: 'overviewAll',
  props: true,
  meta: {
    title: '总览',
    icon: 'overview',
    requiresAuth: true
  },
  component: Layout,
  children: [
    {
      path: '',
      name: 'overview',
      component: Overview,
      meta: {
        icon: 'overview',
        requiresAuth: true,
        currentActive: '/manage/overview/'
      },
      hidden: false
    }
  ]
};
export default overviewRouter;



// WEBPACK FOOTER //
// ./src/router/modules/overviewEnterprise.js